export default __webpack_public_path__ + "static/media/product-5.0829a9a3.webp";